"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadStateFromEnv = loadStateFromEnv;
exports.mapStateToEnv = mapStateToEnv;
exports.createDriverContext = createDriverContext;
exports.updateVersionForTeamsAppYamlFile = updateVersionForTeamsAppYamlFile;
const tslib_1 = require("tslib");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const path_1 = tslib_1.__importDefault(require("path"));
const semver_1 = tslib_1.__importDefault(require("semver"));
const yaml_1 = require("yaml");
const globalVars_1 = require("../../../common/globalVars");
const versionMetadata_1 = require("../../../common/versionMetadata");
// Needs to validate the parameters outside of the function
function loadStateFromEnv(outputEnvVarNames) {
    const result = {};
    for (const [propertyName, envVarName] of outputEnvVarNames) {
        result[propertyName] = process.env[envVarName];
    }
    return result;
}
// Needs to validate the parameters outside of the function
function mapStateToEnv(state, outputEnvVarNames, excludedProperties) {
    const result = new Map();
    for (const [outputName, envVarName] of outputEnvVarNames) {
        if (!excludedProperties?.includes(outputName)) {
            result.set(envVarName, state[outputName]);
        }
    }
    return result;
}
function createDriverContext(inputs) {
    const driverContext = {
        azureAccountProvider: globalVars_1.TOOLS.tokenProvider.azureAccountProvider,
        m365TokenProvider: globalVars_1.TOOLS.tokenProvider.m365TokenProvider,
        ui: globalVars_1.TOOLS.ui,
        progressBar: undefined,
        logProvider: globalVars_1.TOOLS.logProvider,
        telemetryReporter: globalVars_1.TOOLS.telemetryReporter,
        projectPath: inputs.projectPath,
        platform: inputs.platform,
    };
    return driverContext;
}
async function updateVersionForTeamsAppYamlFile(projectPath) {
    for (const yamlFileName of versionMetadata_1.YamlFileNames) {
        const ymlPath = path_1.default.join(projectPath, yamlFileName);
        if (await fs_extra_1.default.pathExists(ymlPath)) {
            const ymlContent = await fs_extra_1.default.readFile(ymlPath, "utf-8");
            const document = (0, yaml_1.parseDocument)(ymlContent);
            const version = document.get("version").slice(1);
            const validVersion = semver_1.default.coerce(version);
            if (validVersion && semver_1.default.lte(validVersion, "1.7.0")) {
                if (semver_1.default.lte(validVersion, "1.6.0")) {
                    convertOutputJsonPathToOutputFolder(document);
                }
                if (semver_1.default.eq(validVersion, "1.3.0")) {
                    renameClientSecret(document);
                }
                document.set("version", "v1.8");
                const docContent = document.toString();
                // yaml-language-server can be like https://aka.ms/teams-toolkit/1.0.0/yaml.schema.json and https://aka.ms/teams-toolkit/v1.2/yaml.schema.json
                const updatedContent = docContent.replace(/(yaml-language-server:\s*\$schema=https:\/\/aka\.ms\/teams-toolkit\/)(v?\d+\.\d+(?:\.\d+)?)(\/yaml\.schema\.json)/, "$1v1.8$3");
                await fs_extra_1.default.writeFile(ymlPath, updatedContent, "utf8");
            }
        }
    }
}
function processSectionsByUse(document, targetUseValue, processor) {
    const sections = ["provision", "publish"];
    sections.forEach((sectionKey) => {
        const section = document.get(sectionKey, true);
        if (section && Array.isArray(section.items)) {
            section.items.forEach((item) => {
                if (item && item.get("uses", true)?.value === targetUseValue) {
                    const withNode = item.get("with", true);
                    if (withNode) {
                        processor(withNode);
                    }
                }
            });
        }
    });
}
function convertOutputJsonPathToOutputFolder(document) {
    processSectionsByUse(document, "teamsApp/zipAppPackage", (withNode) => {
        const outputJsonPath = withNode.get("outputJsonPath", true)?.value;
        if (typeof outputJsonPath === "string") {
            withNode.set("outputFolder", path_1.default.dirname(outputJsonPath));
            withNode.delete("outputJsonPath");
        }
    });
}
function renameClientSecret(document) {
    processSectionsByUse(document, "apiKey/register", (withNode) => {
        const secretValue = withNode.get("clientSecret", true)?.value;
        if (typeof secretValue === "string") {
            withNode.set("primaryClientSecret", secretValue);
            withNode.delete("clientSecret");
        }
    });
}
//# sourceMappingURL=utils.js.map